import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

//Bootstrap
import { Form } from "react-bootstrap";

//API calls
import {
  useGetSifrantVlogaPartnerja,
  useEditOtherPartner,
} from "../../../../services/ProjectDetails/partnerskeOrganizacijeAPI";

//UI components
import FormSelect from "../../../ui/FormSelect";
import FormField from "../../../ui/FormField";
import ErrorMessage from "../../../ui/ErrorMessage";

//Utils
import sifrantSetSelectValueAndLabel from "../../../utils/sifrantSetSelectValueAndLabel";

//Validation schema
import formEditOtherPartnerSchema from "../../../../config/formEditOtherPartner";

const OstaliPartnerjiCardItemEditForm = ({ partner, setIsEditing }) => {
  const { id } = useParams();

  const schema = useMemo(() => formEditOtherPartnerSchema, []);

  //GET Vloge za partnerja
  const { data: sifrantVloga } = useGetSifrantVlogaPartnerja(true);

  //PUT edit other partner
  const {
    mutate: editOtherPartner,
    isPending: isPendingEdit,
    isError,
    error,
    reset: resetMutationError,
  } = useEditOtherPartner(id);

  //INIT form with react-hook-form and zod validation
  const {
    handleSubmit,
    formState: { errors, isDirty },
    control,
    register,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      vlogaID: partner?.vlogaID || null,
      vodjaProjekta: partner?.vodjaProjekta || "",
      kontaktnaOseba: partner?.kontaktnaOseba || "",
    },
  });

  //setSifrantVlogaOptions in format for select component
  const sifrantVlogaOptions = sifrantSetSelectValueAndLabel(sifrantVloga);

  //onSubmit function to call mutation for editing other partner
  const onSubmit = (data) => {
    const payload = {
      partnerID: partner?.partnerID,
      vlogaID: data.vlogaID,
      vodjaProjekta: data.vodjaProjekta,
      kontaktnaOseba: data.kontaktnaOseba,
    };

    editOtherPartner(payload, {
      onSuccess: () => {
        setIsEditing(false);
      },
      onError: () => setTimeout(() => resetMutationError(), 3000),
    });
  };

  return (
    <div className="px-3 pb-3 mt-2">
      <Form onSubmit={handleSubmit((data) => onSubmit(data))}>
        <FormSelect
          label="Vloga partnerja"
          name="vlogaID"
          control={control}
          options={sifrantVlogaOptions}
          validationError={errors.vlogaID?.message}
        />
        <FormField
          label="Vodja projekta"
          formControlType="text"
          register={register("vodjaProjekta")}
        />
        <FormField
          label="Kontaktna oseba"
          formControlType="text"
          register={register("kontaktnaOseba")}
        />
        <button
          type="submit"
          className="btn btn-primary mt-3"
          disabled={!isDirty || isPendingEdit}
        >
          {isPendingEdit ? "Shranjevanje..." : "Shrani"}
        </button>
        <button
          type="button"
          className="btn btn-secondary mt-3 ms-2"
          onClick={() => setIsEditing(false)}
        >
          Prekliči
        </button>
        {isError && <ErrorMessage message={error.message} />}
      </Form>
    </div>
  );
};

export default OstaliPartnerjiCardItemEditForm;
